var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPremiumLockOutline = props => {
  const {
    size,
    color,
    svgProps
  } = props;
  props = {
    width: size || 24,
    height: size || 24,
    color: color || 'currentColor',
    ...svgProps
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 26 26",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 23.834c5.983 0 10.833-4.85 10.833-10.834 0-5.983-4.85-10.833-10.833-10.833C7.017 2.167 2.167 7.017 2.167 13c0 5.983 4.85 10.834 10.833 10.834zm2.708-13.362h.542c.596 0 1.083.511 1.083 1.135v5.675c0 .624-.487 1.135-1.083 1.135h-6.5c-.596 0-1.083-.511-1.083-1.135v-5.675c0-.624.487-1.135 1.083-1.135h.541V9.337C10.291 7.771 11.505 6.5 13 6.5s2.708 1.271 2.708 2.837v1.135zm-4.387-1.135v1.135h3.358V9.337c0-.97-.753-1.759-1.68-1.759-.925 0-1.678.789-1.678 1.76z"
  })));
};
export default SvgPremiumLockOutline;